module.exports = __webpack_public_path__ + "static/media/Image04.ae7fde90.png";